import { render, staticRenderFns } from "./SmallPriceCard.vue?vue&type=template&id=5a465464&scoped=true&"
import script from "./SmallPriceCard.vue?vue&type=script&lang=js&"
export * from "./SmallPriceCard.vue?vue&type=script&lang=js&"
import style0 from "./SmallPriceCard.vue?vue&type=style&index=0&id=5a465464&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a465464",
  null
  
)

export default component.exports